'use client';

import React from 'react';
import BodyWidth from '@/components/layout/BodyWidth';
import Main from '@/components/layout-new/jobseeker/Main';
import { AuthProvider, UserProps } from '@/context/auth';

interface Props extends UserProps {
  footer?: React.ReactNode;
  needViewPort?: boolean;
  outContainerEle?: React.ReactElement;
  isHideUser?: boolean;
}

const Layout = (props: Props) => {
  const { children, user, needViewPort, outContainerEle, isHideUser } = props;

  if (!children) return null;

  return (
    <>
      <BodyWidth needViewPort={needViewPort} />
      <AuthProvider user={user}>
        <Main
          isHideHeader={isHideUser}
          outContainerEle={outContainerEle}
          isSalaryLink={false}
        >
          {children}
        </Main>
      </AuthProvider>
    </>
  );
};

export default Layout;
